import React from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql, withPrefix } from 'gatsby'
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getIsPreviewStatus } from '../state/app';
import { addSlashToStr, getArticleOrCategorySlugs, getArticleOrCategoryBreadcrumbs } from './utilities';
import { useGeneralSettings } from './Hooks/GeneralSettings';
const getData = graphql`
     query {
          site {
               siteMetadata {
                    siteTitle: title
                    siteDesc: description
                    author
                    siteUrl
               }
          }
     }
`


// const mapBreadcrumb = (arr) => {

// }

const Seo = ({ title, path, canonical, description, robots, image, isPreview, category, article, hasBreadcrumb, googleSiteVerificationContent, showAntiFlickerSnippet, pageName, specificPhone, trackingCode }) => {
     const { site } = useStaticQuery(getData)

     const { siteDesc, siteTitle, siteUrl } = site.siteMetadata

     let url_string = '';

     if (typeof path != 'undefined') {
          // Can only read environment variable from .env.* file
          // Reference document: https://www.gatsbyjs.org/docs/environment-variables/#server-side-nodejs
          url_string = path ? addSlashToStr(process.env.GATSBY_DOMAIN + path) : process.env.GATSBY_DOMAIN;
     } else {
          url_string = (typeof window !== `undefined`) ? addSlashToStr(process.env.GATSBY_DOMAIN + (window.location.pathname.charAt(0) == '/' ? window.location.pathname.substr(1) : window.location.pathname)) : '';
     }

     const seoTitle = title != null ? title : siteTitle;

     const seoDescription = description ? description : siteDesc; // Long text in graphql is diffent with long text in contentful preview

     const seoRobots = robots ? <meta name="robots" content={robots} /> : "";

     const seoCanonical = canonical ? addSlashToStr(canonical) : url_string;

     const seoImage = image != null ? (isPreview ? image.fields.file.url : image.file.url) : "//images.ctfassets.net/440y9b545yd9/4DSKXKpmQWwNZUvJ8z4PAT/5861e9555a9f576fd80b6a2876fd8b64/nationwide_sq.jpg";

     var arrGlobal = "";
     var breadcrumbId = "";
     if (typeof hasBreadcrumb != 'undefined' && hasBreadcrumb == true) {
          var urlOrigin = (typeof window !== `undefined`) ? window.location.origin : ''
          breadcrumbId = `,"breadcrumb": {"@id": "${url_string}#breadcrumb"}`;
          if (typeof category != "undefined") {
               var breadcrumbSlug = getArticleOrCategoryBreadcrumbs(category);
               var categorySlug = '/healthzone/' + getArticleOrCategorySlugs(category).reverse().join('/');
          }

          arrGlobal = `${arrGlobal}{"@type": "ListItem","position": ${1},"item": {"@type": "WebPage","@id":"${urlOrigin + "/healthzone/"}","url":"${urlOrigin + "/healthzone/"}","name":"Healthzone"}},`
          if (typeof article != "undefined" && typeof category != "undefined") {
               breadcrumbSlug.reverse().map((val, i) => {
                    arrGlobal = `${arrGlobal}{"@type": "ListItem","position": ${i + 2},"item": {"@type": "WebPage","@id":"${urlOrigin + val.slug + '/'}","url":"${urlOrigin + val.slug + '/'}","name":"${val.breadcrumb}"}},`
               })
               arrGlobal = `${arrGlobal}{"@type": "ListItem","position": ${breadcrumbSlug.length + 2},"item": {"@type": "WebPage","@id":"${url_string}","url":"${url_string}","name":"${article.breadcrumbValue}"}}`
          } else {
               breadcrumbSlug.reverse().map((val, i) => {
                    if (val.slug != categorySlug) {
                         arrGlobal = `${arrGlobal}{"@type": "ListItem","position": ${i + 2},"item": {"@type": "WebPage","@id":"${urlOrigin + val.slug + '/'}","url":"${urlOrigin + val.slug + '/'}","name":"${val.breadcrumb}"}},`
                    } else {
                         arrGlobal = `${arrGlobal}{"@type": "ListItem","position": ${breadcrumbSlug.length + 1},"item": {"@type": "WebPage","@id":"${url_string}","url":"${url_string}","name":"${val.breadcrumb}"}}`
                    }
               })
          }

          arrGlobal = `,{"@type": "BreadcrumbList","@id": "${url_string}#breadcrumb","itemListElement": [${arrGlobal}]}`
     }

     const generalSettings = useGeneralSettings();
     const { optimizeContainerId, showHeaderScript, headerScript } = generalSettings[0].node;

     const listScript = headerScript.childMarkdownRemark.html.match(/<script\b[^>]*>([\s\S]*?)<\/script>/g)
     let newListScript = []

     listScript.forEach(script => {
          if (script.indexOf('<script') > -1) {
               let newScript = {}
               newScript.code = script.match(/<script\b[^>]*>([\s\S]*?)<\/script>/)[1]
               if (script.indexOf('src=') > -1) {
                    let src = script.match(/(src="[\s\S]+")/g)
                    src = src[0].match(/[^src="]([\s\S]+)[^"]/g)
                    newScript.src = src[0]
               }
               if (script.match(/<script\b[^>]*>/)[0].indexOf('async') > -1) {
                    newScript.async = true
               }
               if (script.match(/<script\b[^>]*>/)[0].indexOf('defer') > -1) {
                    newScript.defer = true
               }
               newListScript.push(newScript)
          }
     })

     return (
          <Helmet htmlAttributes={{ lang: 'en' }} title={`${seoTitle}`} >
               <script src={withPrefix('js/utilities.js')} type="text/javascript" />
               {googleSiteVerificationContent && <meta name="google-site-verification" content={googleSiteVerificationContent} />}
               <meta name="description" content={seoDescription} />
               <link rel="canonical" href={seoCanonical} />

               {seoRobots && seoRobots}

               <meta property="og:locale" content="en_US" />
               <meta property="og:type" content="website" />
               <meta property="og:title" content={seoTitle} />
               <meta property="og:url" content={seoCanonical} />
               <meta property="og:description" content={seoDescription} />
               <meta property="og:site_name" content="Nationwide Pet Insurance" />
               <meta property="og:image" content={seoImage} />
               <meta property="og:image:secure_url" content={seoImage} />
               <meta property="fb:app_id" content="" />

               {/* Twitter Card tags */}
               <meta name="twitter:site" content="@NationwidePet" />
               <meta name="twitter:title" content={seoTitle} />
               <meta name="twitter:description" content={seoDescription} />
               <meta name="twitter:image" content={seoImage} />
               <meta name="twitter:card" content="summary_large_image" />
               <meta property="og:image:width" content="1200" />
               <meta property="og:image:height" content="630" />

               <script src={process.env.ENSIGHTEN_BOOTSTRAP_TAGS} />

               <script type="application/ld+json">{`
               {
                    "@context": "http://schema.org",
                    "@graph":[
                         {
                              "@type":"WebSite",
                              "@id":"${url_string}#website",
                              "url":"${url_string}",
                              "name":"Nationwide Pet Insurance",
                              "potentialAction": {
                                   "@type":"SearchAction",
                                   "target":"${url_string}?s={search_term_string}",
                                   "query-input":"required name=search_term_string"
                              }
                         },
                         {
                              "@type":"WebPage",
                              "@id":"${seoCanonical}#webpage",
                              "url":"${seoCanonical}",
                              "inLanguage":"en-US",
                              "name":"${seoTitle}",
                              "isPartOf":{"@id":"${seoCanonical}#website"},
                              "datePublished":"2019-09-06T04:10:11+00:00",
                              "dateModified":"2020-03-09T19:38:28+00:00",
                              "description":"${seoDescription}"
                              ${breadcrumbId}
                         }
                         ${arrGlobal}
                    ]
               }
               `}</script>

               <script>{` 
                         setOmCode('${trackingCode || ''}', window.location.href)
                         setPhoneLocalStorage('${specificPhone || ''}', window.location.href)
                         setCookieTestUser(window.location.href)
                         const pageName = '${pageName}';
                         const getOmValue = localStorage.getItem('Petinsurance_OM') || '';
                         const getPhoneValue = localStorage.getItem('Petinsurance_TrackingPhone') || '';
                         const testUser = getCookieTestUser('testUser') != '' ? getCookieTestUser('testUser') : 'No';
                         const originCode = (getOmValue != '' && getOmValue != 'null') ? getOmValue.substr(0, 2) : '';
                         const trackingCodeA = (getOmValue != '' && getOmValue != 'null') ? getOmValue.substr(2) : '';
                         gtmTrackingDetailDataLayer('prePageview', {
                              pageName: pageName,
                              testUser: testUser,
                              omCode: getOmValue,
                              origin: originCode,
                              trackingCode: trackingCodeA,
                              campaignPhone: getPhoneValue
                         })
               `}
               </script>
               
               <script>{`
                    (function (w, d, s, l, i) {
          w[l] = w[l] || []; w[l].push({
               'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
          }); var f = d.getElementsByTagName(s)[0],
               j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
     })(window, document, 'script', 'dataLayer', '${optimizeContainerId}');`}
               </script>

               {
                    showAntiFlickerSnippet && optimizeContainerId && (
                         <style>{`.async-hide {opacity: 0 !important} `}</style>
                    )
               }
               {
                    showAntiFlickerSnippet && optimizeContainerId && (
                         <script>{`(function(a,s,y,n,c,h,i,d,e){s.className += ' ' + y;h.start=1*new Date;
                         h.end=i=function(){s.className = s.className.replace(RegExp(' ?' + y), '')};
                         (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
                         })(window,document.documentElement,'async-hide','dataLayer',4000,
                         {'${optimizeContainerId}':true});`}</script>
                    )
               }
               {
                    showHeaderScript && newListScript.map((script, index) => {
                         if (script.src) {
                              if (script.async) {
                                   return (
                                        <script key={index} src={script.src ? script.src : null} async></script>
                                   )
                              }
                              if (script.defer) {
                                   return (
                                        <script key={index} src={script.src ? script.src : null} defer></script>
                                   )
                              }
                              return (
                                   <script key={index} src={script.src ? script.src : null} ></script>
                              )
                         }
                         return (
                              <script key={index} >{script.code}</script>
                         )
                    })
               }
          </Helmet>
     )
}

Seo.propTypes = {
     isPreview: PropTypes.bool,
}

const mapStateToProps = (state) => {
     return {
          isPreview: getIsPreviewStatus(state),
     };
}

export default connect(mapStateToProps)(Seo);
